import { TierEnterprise, TierEnterpriseTrial, TierPlus, TierPremium, TierStandard, TierTeam } from "@eventr/common";
import {
  ColoursObj,
  MainButton,
  MobileFrameDialog,
  SelectInputField,
  TextInputField,
  Typography,
  useDialogStore,
} from "@eventr/common-storybook";
import { Box, DialogActions, DialogTitle, Divider } from "@mui/material";
import { useState } from "react";
import { EventrGatewayAPI } from "../../data/gateway.api";
import { bs } from "../../state/bound.store";
import { useOverlayStore } from "../../state/overlayState/overlay.store";

export const fakePurchase = async () => {
  useDialogStore.getState().replaceDialog({
    kind: "custom",
    node: <FakePurchaseDialog />,
    backdropClosable: true,
  });
};

const FakePurchaseDialog = () => {
  const [hours, setHours] = useState("24");
  const [tier, setTier] = useState(TierTeam.id);

  const onBuy = async () => {
    useOverlayStore.getState().setLoading(true);
    await EventrGatewayAPI.organisation.fakeSub(bs().selectedOrg?.name ?? "", hours, tier);
    useDialogStore.getState().clearDialog();
    useOverlayStore.getState().setLoading(false);
  };
  return (
    <MobileFrameDialog>
      <DialogTitle style={{ background: ColoursObj.backgrounds.dialogue }}>
        Fake EventR pro subsctibtion only works non-production
      </DialogTitle>
      <Divider
        orientation="horizontal"
        flexItem
        style={{
          background: ColoursObj.shades.shade3,
          height: "auto",
        }}
      />

      <Box sx={{
        height: "16px"
      }} />
      <TextInputField
        value={hours}
        onChange={(h) => {
          setHours(h.target.value);
        }}
        fieldLabel="expires in X hours "
      />
      <Box sx={{
        height: "16px"
      }} />
      <SelectInputField
        fieldLabel="Select tier"
        defaultValue={tier}
        onChange={(v) => {
          setTier(v.target.value as string);
        }}
        data={[
          { id: TierTeam.id, displayName: TierTeam.longName },
          { id: TierPlus.id, displayName: TierPlus.longName },
          { id: TierStandard.id, displayName: TierStandard.longName },
          { id: TierPremium.id, displayName: TierPremium.longName },
          {
            id: TierEnterprise.id,
            displayName: TierEnterprise.longName,
          },
          {
            id: TierEnterpriseTrial.id,
            displayName: TierEnterpriseTrial.longName,
          },
        ]}
      />
      <Box sx={{
        height: "16px"
      }} />
      <DialogActions
        style={{
          padding: "0px",
        }}
      >
        <MainButton onClick={onBuy} style={{ width: "100%" }}>
          <Typography>Buy</Typography>
        </MainButton>
      </DialogActions>
    </MobileFrameDialog>
  );
};
